// extracted by mini-css-extract-plugin
module.exports = {"Title":"Training_Title__2O2RH","TrainingContainer":"Training_TrainingContainer__2tonh","IframeWarrper":"Training_IframeWarrper__1xAw5","Description":"Training_Description__10BkY"};